import { Injectable } from '@angular/core';
import { BaseclientService } from '../baseclient.service';

import { Observable, BehaviorSubject, from } from 'rxjs';
import { clientBookingData } from 'src/app/models/interfaces/interfaces';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class TableReservationClientService {

  private clientBookingData: BehaviorSubject<clientBookingData> = new BehaviorSubject<clientBookingData>({
    n_person: null,
    date: null,
    hour: null,
    serviceId: null,
    comment: null
  });

  constructor(private base: BaseclientService) { }


  /**
   * @description Récupère les slots valides pour le booking qui correspondent à la date
   * @param {number} person
   * @param {posId} posId
   * @param {string} date
   */
  getValidBookingSlots(person: number, posId: number, date: string): Promise<any> {
    const params = {
      person: person,
      pos_id: posId,
      date: date
    }
    return this.base.postBase("getBookingSlots", params);
  }

//   /**
//  * @description Crée une réservation
//  * @param {number} person
//  * @param {number} serviceId
//  * @param {number} posId
//  * @param {number} userId
//  * @param {string} date
//  * @param {string} hour
//  * @param {string} comment
//  */
//   createBooking(person: any, serviceId: any, posId: any, userId: any, date: any, hour: any, comment?: any, payment_type?: any, paypal_order_id?: any,
//     payment_intent_id?: any, currCard?: any, deposit?: any): Promise<any> {


//     const params:any = {
//       person: person,
//       service_id: serviceId,
//       pos_id: posId,
//       user_id: userId,
//       date: date,
//       hour: hour,
//       comment: comment,

//       payment_type: payment_type
//       // ,
//       // paypal_order_id: paypal_order_id,
//       // payment_intent_id: payment_intent_id,
//       // currCard: currCard,
//     }




//     /**
//      * Stripe
//      */
//     if (deposit) {

//       if (params.payment_type === "online" || params.payment_type === "secure_counter") {
//         payment_intent_id ? params["payment_intent_id"] = payment_intent_id : params["payment_method_id"] = currCard.id;
//       } else if (params.payment_type === "bancontact" && payment_intent_id) {
//         params["payment_intent_id"] = payment_intent_id;
//       }
//       else if (params.payment_type === "payzen") {

//         params["payment_intent_id"] = payment_intent_id;
//       }

//       /**
//        * Paypal
//        */
//       if (params.payment_type === "online_paypal" || params.payment_type === "secure_counter_paypal") {
//         params["paypal_order_id"] = paypal_order_id ? paypal_order_id : null;
//       }

//       if (deposit) { params["deposit"] = deposit }
//     }



//     return this.base.postBase("createBooking", params);

//   }


  /**
   * @description Retourn le behaviorSubject en question
   */
  getClientBookingData(): Observable<clientBookingData> {
    return this.clientBookingData.asObservable();
  }

  /**
   * @description Set le behaviorSubject en question
   * @param {clientBookingData} clientBookingData
   */
  setClientBookingData(clientBookingData: clientBookingData): void {
    this.clientBookingData.next(clientBookingData);
  }

  /**
   * @description Récupère les points of sales reservation valides
   * @param {user_id} user_id
   */
  getBookingPointofSales(userId: number): Promise<any> {
    const params = {
      user_id: userId,
    }
    return this.base.getBase("getBookingPointsOfSale", params);
  }

  /**
  * @description Récupère les reservations du client
  * @param {string} dateFrom
  * @param {string} dateTo
  */

  getBookings(dateFrom?: string, dateTo?: string): Observable<any> {
    const params = {
      date_from: dateFrom,
      date_to: dateTo
    }
    return from(this.base.postBase("getClientBookings", params)).pipe(
      map(data => data.client_bookings)
    )
  }


  setPaymentPayzen(orderId: string | number, jsonPayzen: any): Promise<any> {
    const params = {
      order_id: orderId,
      jsonPayzen: jsonPayzen
    };

    return this.base.postBase("paymentBookingSucceeded", params);


  }

}
